import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MarkdownComponent from 'components/shared/MarkdownComponent';
import { useRef, useState } from 'react';
import {
  StyledFaqs,
  StyledFaqsButton,
  StyledFaqsContent,
  StyledFaqsIcon,
  StyledFaqsQuestion,
  StyledFaqsText,
  StyledFaqsTitle,
} from './Faqs.styled';

function Faqs({ faqsItem, migratedToMarkdown }) {
  const [setActive, setActiveState] = useState('');
  const [setHeight, setHeightState] = useState('0px');

  const content = useRef(null);

  function toggleAccordion() {
    setActiveState(setActive === '' ? 'is-active' : '');
    setHeightState(
      setActive === 'is-active' ? '0px' : `${content.current.scrollHeight}px`,
    );
  }

  return (
    <StyledFaqs>
      <StyledFaqsQuestion>
        <StyledFaqsButton className={`${setActive}`} onClick={toggleAccordion}>
          <StyledFaqsTitle>{faqsItem.q}</StyledFaqsTitle>
          <StyledFaqsIcon>
            <FontAwesomeIcon icon={faCaretDown} />
          </StyledFaqsIcon>
        </StyledFaqsButton>
      </StyledFaqsQuestion>

      <StyledFaqsContent ref={content} style={{ maxHeight: `${setHeight}` }}>
        <StyledFaqsText>
        {migratedToMarkdown ? (
          <MarkdownComponent content={faqsItem.a || ''} />
        ) : (
          <span
            dangerouslySetInnerHTML={{ __html: faqsItem.a || '' }}
          ></span>
        )}
        </StyledFaqsText>
      </StyledFaqsContent>
    </StyledFaqs>
  );
}

export default Faqs;
